import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import HeaderDropdown from './HeaderDropdown';
import './HeaderDropdown.css';

const AboutUsDropdown = ({ isOpen, onMouseEnter, onMouseLeave }) => {
    const [activeTab, setActiveTab] = useState('about');

    const categories = [
        { id: 'about', label: 'About Us' },
        { id: 'policy', label: 'Policy & Disclosure' }
    ];

    return (
        <HeaderDropdown
            isOpen={isOpen}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            categories={categories}
            activeCategory={activeTab}
            onCategoryHover={setActiveTab}
        >
            {activeTab === 'about' && (
                <div className="about-dropdown-content">
                    <div className="about-dropdown-section">
                        <h3 className="about-dropdown-heading">WCFL</h3>
                        <ul className="about-dropdown-list">
                            <li><Link to="/company-profile">Company Profile</Link></li>
                            <li><a href="#leadership-team" style={{ opacity: 0.5, pointerEvents: 'none' }}>Leadership Team (Coming Soon)</a></li>
                            <li><Link to="/vision-values">Our Vision and Values</Link></li>
                            <li><a href="#achievements" style={{ opacity: 0.5, pointerEvents: 'none' }}>Our Achievements (Coming Soon)</a></li>
                            <li><Link to="/careers">Career</Link></li>
                        </ul>
                    </div>

                    <div className="about-info-card">
                        <div className="about-info-card__header">
                            <div className="about-info-card__logo"></div>
                            <span className="about-info-card__brand">WE CARE FINSERV</span>
                        </div>
                        <h3 className="about-info-card__title">We Care Finserv Limited</h3>
                        <p className="about-info-card__desc">
                            We Care Finserv Limited ("WCFL") is a systemically important NBFC providing Loans and Insurance solutions.
                        </p>
                        <div className="about-info-card__stats">
                            <div className="about-stat">
                                <span className="about-stat__icon">🏢</span>
                                <span className="about-stat__label">Branches:</span>
                                <span className="about-stat__value">28</span>
                            </div>
                            <div className="about-stat">
                                <span className="about-stat__icon">🤝</span>
                                <span className="about-stat__label">Partners:</span>
                                <span className="about-stat__value">120+</span>
                            </div>
                            <div className="about-stat">
                                <span className="about-stat__icon">📊</span>
                                <span className="about-stat__label">Lending:</span>
                                <span className="about-stat__value">INR 1.78 Cr</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {activeTab === 'policy' && (
                <div className="about-dropdown-content">
                    <div className="about-dropdown-section">
                        <h3 className="about-dropdown-heading">Business Policies</h3>
                        <ul className="about-dropdown-list">
                            <li><a href="#digital-referral" style={{ opacity: 0.5, pointerEvents: 'none' }}>Digital Referral Partners (Coming Soon)</a></li>
                            <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
                        </ul>
                    </div>
                </div>
            )}
        </HeaderDropdown>
    );
};

export default AboutUsDropdown;
